// https://github.com/envato/marketplace/blob/master/engines/search/app/models/search/faceting_search_service.rb#L216-L230
export default [
  'attribute_key',
  'attribute_value',
  'category',
  'compatible_with',
  'price_max',
  'resolution_min',
  'tags',
  'term',
  'size',
  'sort',
  'vocals_in_audio',
  'item_id',
  'page'
]
